import { render, staticRenderFns } from "./AzSsoAuth.vue?vue&type=template&id=a63f883c"
import script from "./AzSsoAuth.vue?vue&type=script&lang=js"
export * from "./AzSsoAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports